import axios from "axios";

const souzacambos = axios.create({
    baseURL: 'https://souzacambos.com.br/api/tecelagem/',
    headers: {
        'Accept' : 'application/json'
    }
});

export default souzacambos